import { useSuspenseQuery } from '@tanstack/react-query';
import { getCaseEligibility } from '@actions';
import { useDispatch } from 'react-redux';
import { useSessionAppointment } from '@hooks/useSessionAppointment';

export const useEligibilityChecks = () => {
  const dispatch = useDispatch();
  const { appointment } = useSessionAppointment();

  return useSuspenseQuery({
    queryKey: ['eligibilityChecks', appointment.case_id],
    queryFn: () => dispatch(getCaseEligibility(appointment.case_id)),
    select: (data) => {
      const { eligibility_check_complete, virtual_only_reason } = data.case_eligibility[0];
      const eligibility = data.case_eligibility[0].eligibility?.[0] || {};
      const { F2F_CONSULT_CHECK = 'false', F2F_PHYSIO_CHECK = 'false', VIRTUAL_ONLY = 'false' } = eligibility;

      return {
        eligibility_check_complete,
        virtual_only_reason,
        F2F_CONSULT_CHECK: F2F_CONSULT_CHECK === 'true',
        F2F_PHYSIO_CHECK: F2F_PHYSIO_CHECK === 'true',
        VIRTUAL_ONLY: VIRTUAL_ONLY === 'true'
      };
    },
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });
};
